import get from 'lodash.get';

export const transform = (data) => {
  let scores = [];
  let names = [];
  let levels = [];
  let ids = [];
  data.forEach((item) => {
    scores.push(item.score);
    ids.push(item.id);
    names.push(get(item, 'first_name', 'NAME MISSING') + ' ' + get(item, 'last_name', 'NAME MISSING') )
    levels.push(item.level);
  });

  return { scores, names, levels, ids };
}

export default { transform };